import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})


export class VideoThumbnailService {
  async generateThumbnail(videoUrl: any): Promise<string[]> {

    var defaultThumbnailProvider : IThumbnailProvider = new DefaultThumbailProvider();
    var thumbnailProvider: IThumbnailProvider = defaultThumbnailProvider;

    if (videoUrl.match(/youtube\.com|youtu\.be/i)) {
      thumbnailProvider = new YoutubeThumbnailProvdier(this.http);
    }
    if (videoUrl.match(/vimeo\.com/i)) {
      thumbnailProvider = new VimeoThumbnailProvdier(this.http);
    }
    else {
      // No provider detected
    }

    try{
      var thumbnails = await thumbnailProvider.generateThumbnails(videoUrl);
      return thumbnails;
    }
    catch(err){
      thumbnails = await defaultThumbnailProvider.generateThumbnails(videoUrl);
      return thumbnails;
    }
  }

  constructor(private http: HttpClient) {
    this.http = http;
  }
}


interface IThumbnailProvider {
  generateThumbnails(videoUrl: string): Promise<string[]>;
}

class YoutubeThumbnailProvdier implements IThumbnailProvider {

  constructor(private http: HttpClient) {}

  async generateThumbnails(videoUrl: string): Promise<string[]> {
    const oEmbedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(videoUrl)}&format=json`;
    const data: any = await new Promise((resolve, reject) => {
      this.http.get(oEmbedUrl).subscribe(resolve, reject);
    });
    if (data && data.thumbnail_url) {
      return [data.thumbnail_url];
    }
    throw new Error('Unable to get YouTube thumbnail from oEmbed response');
  }
}

class VimeoThumbnailProvdier implements IThumbnailProvider {

  constructor(private http: HttpClient) {
    this.http = http;
  }

  async generateThumbnails(thumb: string): Promise<string[]> {


    var thumbs: string[] = [];
    var videoIdMatch = thumb.match(/https?\:\/\/vimeo\.com\/([^ &]+)/);

    if (videoIdMatch) {
      var videoId = videoIdMatch[1];
      var metaEndpoint = `https://vimeo.com/api/v2/video/${videoId}.json`
      var _http = this.http;
      try{
        var data: any = await Promise.resolve(new Promise((fulfil, reject) => {
          _http.get(metaEndpoint)
            .subscribe(json => {
              return fulfil(json);
            },
              (err) => {
                  return reject(err);
              });
        }));

        if (Array.isArray(data) && data.length > 0 && data[0].thumbnail_large) {
          thumbs.push(data[0].thumbnail_large);
        }
      }
      catch(err){
        throw new Error("Failed to get video thumbnail from vimeo. Is the URL correct?")
      }

      return thumbs;
    }
    else {
      throw new Error("Unable to determin Youtube Video ID, are you sure this is a valid youtube link?")
    }
  }
}


class DefaultThumbailProvider implements IThumbnailProvider {
  generateThumbnails(): Promise<string[]> {
    var arr : string[] = ["https://cdn.failteireland.ie/failteireland/video-thumbnail.png"]
    return Promise.resolve(arr);
  }

}

